module.exports = ".th-sn {\n  width: 150px; }\n\n.th {\n  vertical-align: middle; }\n\n.collapse-block {\n  display: inline-block;\n  white-space: nowrap; }\n"